/**
 * @generated SignedSource<<b9ab999d6540318d5fc5a8934461f893>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TestsFilterCountsFragment$data = {
  readonly all: number | null;
  readonly failed: number | null;
  readonly ignored: number | null;
  readonly muted: number | null;
  readonly newFailed: number | null;
  readonly success: number | null;
  readonly " $fragmentType": "TestsFilterCountsFragment";
};
export type TestsFilterCountsFragment$key = {
  readonly " $data"?: TestsFilterCountsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TestsFilterCountsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TestsFilterCountsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "all",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ignored",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "success",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "muted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "failed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newFailed",
      "storageKey": null
    }
  ],
  "type": "TestCounters",
  "abstractKey": null
};

(node as any).hash = "6c58bc9f18457214ade80491db1f4037";

export default node;
